import { Feature } from '@/pinia/feature'

export const attachments: Feature = {
  name: 'attachments',
  enabled: true,
  access: [
    'FEAT_FILE_ADMIN',
    'FEAT_FILE_CREATOR',
    'FEAT_FILE_EDITOR',
    'FEAT_FILE_READER',
    'FEAT_LINK_ADMIN',
    'FEAT_LINK_CREATOR',
    'FEAT_LINK_EDITOR',
    'FEAT_LINK_READER'
  ],
  title: {
    en: 'Attachments',
    sv: 'Bilagor'
  },
  component: 'FeatureCard',
  isRoute: true,
  props: {
    icon: 'IconPaperclip',
    disableIsDrawPointActive: true,
    enableFullscreen: true,
    size: 'small',
    subtitle: {
      sv: 'Bilagetyper',
      en: 'Attachment types'
    }
  },
  children: [
    {
      name: 'attachments',
      enabled: true,
      title: {
        en: 'Attachments',
        sv: 'Bilagor'
      },
      children: [
        {
          name: 'files',
          enabled: true,
          access: ['FEAT_FILE_ADMIN', 'FEAT_FILE_CREATOR', 'FEAT_FILE_EDITOR', 'FEAT_FILE_READER'],
          title: {
            en: 'Files',
            sv: 'Filer'
          },
          component: 'FilesDashboard',
          isRoute: true,
          props: {
            icon: 'IconInsertDriveFile',
            disableIsDrawPointActive: true,
            fullscreen: false
          }
        },
        {
          name: 'links',
          enabled: true,
          access: ['FEAT_LINK_ADMIN', 'FEAT_LINK_CREATOR', 'FEAT_LINK_EDITOR', 'FEAT_LINK_READER'],
          title: {
            en: 'Links',
            sv: 'Länkar'
          },
          component: 'LinksDashboard',
          isRoute: true,
          props: {
            icon: 'IconLinkMedium',
            disableIsDrawPointActive: true,
            fullscreen: false
          }
        }
      ]
    }
  ]
}
